import Hero from "../components/Hero"
import NormativoComponent from "../components/NormativoComponent"
import heroplan from "../assets/img/banners/cumplimiento-normativo.png"
import { useEffect } from "react"

export default function PlanNormativo() {
    
    useEffect(() => {
        document.title = "ProMedic - Cumplimiento Normativo"
    }, [])
    
    return(
        <>
            <Hero img={heroplan} position="relative" />
            <NormativoComponent />
        </>
    )
}